<div class="modal-container">
  <div class="modal-content">
    <div class="modal-header">
      <h4
        class="modal-title"
        id="modal-basic-title"
        [innerHtml]="'cart.quickOrder.clearModal.title' | cxTranslate"
      ></h4>
      <button type="button" class="close" aria-label="Close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-info" [innerHtml]="'cart.quickOrder.clearModal.modalInfo' | cxTranslate"></div>
      <div class="modal-info-desc" [innerHtml]="'cart.quickOrder.clearModal.modalInfoDesc' | cxTranslate"></div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-default secondary-btn cancel-btn mw-120"
        [ngClass]="{ notEn: customizeStylingButtons(activeLanguage$ | async) }"
        [innerHtml]="'cart.quickOrder.clearModal.cancel' | cxTranslate"
        (click)="closeModal('Cross click')"
      ></button>
      <button
        type="button"
        class="btn btn-outline-default primary-btn save-btn mw-120"
        [ngClass]="{ notEn: customizeStylingButtons(activeLanguage$ | async) }"
        [innerHtml]="'cart.quickOrder.clearModal.continue' | cxTranslate"
        (click)="clearEntries()"
      ></button>
    </div>
  </div>
</div>
